import React from 'react'
import { AuthorDto } from '../../../api/Dtos/profileDto'
import ReadMore from './ReadMore'
interface infoData {
    submittedData:any
  }
const AuthorInfo:React.FC<infoData>=({submittedData})=> {
  return (
    <>
    {submittedData?.authorDtos && submittedData?.authorDtos?.length > 0  &&
       <div className='bg-white p-8 mt-5'>
        {/* <p className="border-b-2 border-gray-200"></p> */}
        <div className="">
          <p className="text-primary-color font-semibold text-2xl border-b pb-4 border-b-gray-200">
          Authors
          </p>
          
       <div className="grid grid-cols-2 gap-8 pt-1 pb-12 mt-6">
                                    {submittedData?.authorDtos?.map((item:AuthorDto, index:number) => (
                                      <div className=" border border-gray-200 rounded-lg  p-4 w-full">
                                        <div className="flex gap-1.5 w-full">
                                          <img src={item?.imageDto?.documentUrl ||'/images/dummpComapnyLogo.svg'} className="size-[150px] mr-3 rounded-[4px]" />
                                          <div className=" w-full">
                                            <p className="font-bold text-lg mb-1.5 text-gray-900">
                                              {item?.name}
                                            </p>
                                            {
                                              item?.email && 
                                              <p className=" flex items-center  font-semibold text-sm text-gray-700 pt-1.5 break-all">
                                              <img src='/images/EmailIcon.svg' className='mr-2' /> {item?.email}
                                            </p>
                                            }
                                          
                                            {item?.contactNo &&
                                            <p className="flex items-center font-semibold text-sm text-gray-700 pt-1.5 break-all">
                                            <img src='/images/PhoneIcon.svg' className='mr-2' /> {item?.contactNo }
                                            </p>}
                                            <div className="pt-2 pr-2">
                                           {item?.address &&
                                              <div className="flex font-semibold text-sm text-gray-700 gap-2 items-end cursor-pointer ">
                                                <img src="/images/location_icon.svg" />
                                                <p className="line-clamp-3">{item?.address}</p>
                                              </div>}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="pt-6 font-Inter text-sm pr-2">
                                          <p className="font-normal text-[#111827] line-clamp-3">
                                          <div className="mt-3 text-sm">
        <ReadMore text={item?.bio } lines={2} />
      </div>
                                          
                                          </p>
                                        </div>
                                      </div>))}
                                     
                                    </div>
          </div></div>}</>
  )
}

export default AuthorInfo
